"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Honeycomb = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
const PublicConfig_1 = require("../../Config/PublicConfig");
const Utils_1 = require("../../Utils/Utils");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const libhoney_1 = __importDefault(require("libhoney"));
class Honeycomb {
    init() {
        const config = (0, PublicConfig_1.publicConfig)();
        this.libhoney = new libhoney_1.default({
            writeKey: config.honeycomb.limitedWriteKey,
            dataset: "frontend",
        });
    }
    pageView(info) {
        const userAgent = navigator.userAgent;
        const userDeviceInformation = (0, Utils_1.getDeviceInfoFromUserAgent)(userAgent);
        this.libhoney.sendNow({
            anonymousId: info.sessionId,
            userId: info.userId,
            channel: typeof window !== "undefined" ? "web" : "server",
            properties: {
                title: info.title,
                path: info.path,
                url: info.url,
                referrer: info.referrer,
                assumedBySuperAdmin: info.assumedBySuperAdmin,
                isVisualpingEmployee: info.isVisualpingEmployee,
            },
            context: {
                device: userDeviceInformation.device,
                os: userDeviceInformation.os,
                screen: userDeviceInformation.screen,
                userAgent: userAgent,
                traits: {},
            },
        });
    }
    track(event, isOrgEvent) {
        let deviceInformation = {};
        if (typeof window !== "undefined" && !isOrgEvent) {
            const userAgent = navigator.userAgent;
            const userDeviceInformation = (0, Utils_1.getDeviceInfoFromUserAgent)(userAgent);
            deviceInformation = {
                device: userDeviceInformation.device,
                os: userDeviceInformation.os,
                screen: userDeviceInformation.screen,
                userAgent: userAgent,
            };
        }
        const payload = {
            anonymousId: event.sessionId,
            userId: event.userId,
            properties: Object.assign(Object.assign({}, event.properties), { eventCategory: event.category }),
            channel: typeof window !== "undefined" ? "web" : "server",
            context: Object.assign({
                ip: event.clientIpAddr,
                correlationId: event.requestCorrelationId
                    ? { requestCorrelationId: event.requestCorrelationId, sessionId: event.sessionId }
                    : undefined,
            }, deviceInformation),
            event: event.name,
            timestamp: new Date().toISOString(),
        };
        this.libhoney.sendNow(payload);
    }
}
exports.Honeycomb = Honeycomb;
//# sourceMappingURL=Honeycomb.js.map